import React from "react";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Image from "next/image";
import Link from "next/link";

import Context from "@/context/Context";
import PageHead from "@/pages/Head";
import FooterOne from "@/components/Footer/Footer-One";
import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import BreadCrumb from "@/components/Common/BreadCrumb";

import worldSchoolingImg from "@/public/images/families/world_schooling_1.jpg";
import worldSchoolingImg2 from "@/public/images/families/world_schooling_2.jpg";

const WorldSchooling = () => {
  return (
    <>
      <PageHead title="Worldschooling - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <BreadCrumb
            title="Worldschooling"
            text="Worldschooling" 
            actionButtonText="Let's Chat"
            actionButtonLink="https://wa.me/+573235055710" />
          
          <div className=" bg-color-white mt--30 flex-center">
            <div className="container col-lg-8">
              <h4 className="title text-align-center">
                Adopting global education in a rural and bilingual environment.
              </h4>
              <div className="flex-center mt--30 mb--30 ">
                <video width="360" height="520" poster="/images/partners/logo.png" controls>
                  <source src="/video/menfis_worldschooling.mp4" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <p className="description mt--30 mb--15">
                At Menfis, we integrate global education into every aspect of our educational approach. In a unique environment where learning goes beyond the classroom, we combine academic excellence with hands-on experiences that connect students with the world.
              </p>
              <Image
                className="w-100 rbt-radius"
                src={worldSchoolingImg}
                width={407}
                height={638}
                property="true"
                alt="worldschooling families image"
              />
              <p className="description mt--15 mb--15">
                Our bilingual extracurricular programs allow students to experience the world immersively, from outdoor explorations to cultural exchanges and community projects. Through these, they develop a deep understanding of different cultures and global issues.
              </p>
              <div className="bg-color-white">
                <div className="container">
                  <div className="row g-5 align-items-center flex-center">
                    <div className="col-lg-5">
                      <Image
                        className="w-100 rbt-radius"
                        src={worldSchoolingImg2}
                        width={550}
                        height={600}
                        property="true"
                        alt="worldschooling travel image"
                      />
                    </div>
                    <div className="col-lg-5">
                      <div className="inner pl--50 pl_lg--0 pl_md--0 pl_sm--0">
                        <p className="description">
                          This approach attracts international families who value a holistic education. Our programs not only teach a second language but also foster critical thinking, creativity, and a sense of global citizenship. At Menfis School, we prepare our students to thrive in an interconnected world, offering an education that is both academic and experiential.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-8 col-12 mt--30 mb--30">
                <div className="footer-widget">
                  <h5 className="ft-title">Connect with Us and Be Part of Our Community</h5>
                  <ul className="ft-link">
                    <li>
                      <span>Director: </span>
                      Glen Galindo
                    </li>
                    <li>
                      <span>Phone: </span>
                      <Link href="tel:+573235055710">+57 323 5055710</Link>
                    </li>
                    <li>
                      <span>Whatsapp: </span>
                      <Link href="https://wa.me/+573235055710" target="_blank">+57 323 5055710</Link>
                    </li>
                    <li>
                      <span>E-mail:</span>{" "}
                      <Link href="mailto:WorldSchooling@mingahouse.org">
                        WorldSchooling@mingahouse.org
                      </Link>
                    </li>
                    <li>
                      <span>Facebook Community:</span>{" "}
                      <Link href="https://www.facebook.com/groups/worldschoolinghubcolombia" target="_blank">
                        Join our Facebook group
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <h4 className="title mb--30 mt--30">
                Join us at Menfis and experience a new opportunity to learn, grow, and connect with the world.
              </h4>
            </div>
          </div>
          <Separator />
          <BackToTop />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default WorldSchooling;
